import React from "react";
import { FiCheck } from "react-icons/fi";

/**
 * Compact read-receipt line: a double-check glyph + "Seen by …" with any
 * pending recipients.
 *
 * @param {Object} props
 * @param {string[]} [props.seenBy=[]] - Names who have seen the message.
 * @param {string[]} [props.pending=[]] - Names for whom delivery is pending.
 */
export const ReadReceipt = ({ seenBy = [], pending = [] }) => {
  if (seenBy.length === 0 && pending.length === 0) return null;

  return (
    <div className="mt-0.5 flex flex-wrap items-center justify-end gap-x-2 text-[11px]">
      {seenBy.length > 0 && (
        <span className="inline-flex items-center gap-1 text-success">
          <span className="relative inline-flex h-3 w-4" aria-hidden="true">
            <FiCheck size={12} className="absolute left-0" strokeWidth={2.5} />
            <FiCheck size={12} className="absolute left-[5px]" strokeWidth={2.5} />
          </span>
          <span className="truncate">Seen by {seenBy.join(", ")}</span>
        </span>
      )}
      {pending.map((name, i) => (
        <span key={`${name}-${i}`} className="text-gray-400">
          {name} (pending)
        </span>
      ))}
    </div>
  );
};
